import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

/**
 * Hook for generating file download URLs
 */
export const generateFileAccessURLMutationAtom = createMutationAtomFactory(
  'sales.generateFileAccessURL',
  (params: { fileIds: string[]; expirySeconds?: number }) => ({
    filesGenerateFileAccessURL: {
      __args: {
        fileIds: params.fileIds,
        expirySeconds: params.expirySeconds || 3600, // Default 1 hour
      },
      results: {
        fileId: true,
        url: true,
        expiresAt: true,
        error: true,
      },
    },
  }),
);

export const $generateFileAccessURL = generateFileAccessURLMutationAtom();
